import React, {Dispatch, SetStateAction} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import {DocusealForm} from '@docuseal/react'
import {useIntl} from 'react-intl'
import {updateSignatureStatusApi} from '../core/_requests'
import {useAuth} from '../../auth'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import { removeNullFields } from '../../../core/_util'

const SignInModal = ({
  showSignInModal,
  setShowSignInModal,
  signUrl,
  signatoryEmail,
  getDocuments,
  handleViewDocument,
  submissionId,
  signatoryId,
  setSignatoryLoading,
  getDashboardCounts,
  documentName
}: {
  showSignInModal: boolean
  setShowSignInModal: Dispatch<SetStateAction<boolean>>
  signUrl: string
  signatoryEmail: string
  getDocuments: () => {}
  handleViewDocument?: (submissionId: number) => void
  submissionId?: number
  signatoryId: number
  setSignatoryLoading: Dispatch<SetStateAction<boolean>>
  getDashboardCounts: () => void
  documentName:string
}) => {
  const {formatMessage} = useIntl()
  const {currentUser, companyId} = useAuth()
  return (
    <Modal
      show={showSignInModal}
      size='xl'
      onHide={() => {
        setShowSignInModal(false)
      }}
      aria-labelledby='contained-modal-title-vcenter'
      centered
      className='template-modal-container'
    >
      <Modal.Header>
        <div className='w-100 d-flex justify-content-between align-items-center'>
          <div className='d-flex'>
            <div
              className='d-flex align-items-center cursor-pointer'
              onClick={() => {
                setShowSignInModal(false)
              }}
            >
              <KTSVG path={toAbsoluteUrl('/media/icons/digital-signing/ic_close.svg')} />
            </div>
            <div className='ps-4 font-size-20 fw-bold'>
              {formatMessage({id: 'Add your signature'})}
            </div>
          </div>
          <ToolTipUI tooltipText={formatMessage({id: 'View the document'})} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className='w-100'>
          <DocusealForm
            src={signUrl}
            expand={false}
            email={signatoryEmail}
            customCss='#expand_form_button {background: #4776E6;border-color:#4776E6;}#submit_form_button {background: #4776E6;border-color:#4776E6;color:white;}'
            sendCopyEmail={false}
            withSendCopyButton={false}
            allowToResubmit={false}
            withDownloadButton={false}
            onComplete={async (data) => {
              try {
                setShowSignInModal(false)
                setSignatoryLoading(true)

                const {
                  data: {success},
                } = await updateSignatureStatusApi(signatoryId, companyId!)
                if (success) {
                  if (handleViewDocument && submissionId) {
                    await handleViewDocument(submissionId)
                  }
                  
                  TagManager.dataLayer({
                    dataLayer: {
                      event: GTMEvent.DigitalSigningDocumentSignedSuccessful,
                      metadata: removeNullFields({
                        document_name: documentName,
                        signer_name: `${currentUser?.firstName} ${currentUser?.lastName}`,
                        signer_email: currentUser?.email,
                        signing_date: new Date().toString(),
                        company_id:companyId,
                        user_id: currentUser?.userId,
                      }),
                    },
                  })
                } else {
                  TagManager.dataLayer({
                    dataLayer: {
                      event: GTMEvent.DigitalSigningDocumentSignedFailed,
                      metadata: removeNullFields({
                        document_name: documentName,
                        signer_name: `${currentUser?.firstName} ${currentUser?.lastName}`,
                        signer_email: currentUser?.email,
                        signing_date: new Date().toString(),
                        company_id:companyId,
                        user_id: currentUser?.userId,
                      }),
                    },
                  })
                }

                getDocuments()
              } catch (error) {
                console.error('Error occurred:', error)
              } finally {
                setSignatoryLoading(false)
              }
              getDocuments()
              getDashboardCounts()
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SignInModal
